import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { MeetingSchedulerService } from '@self-serve/interface/calendar.abstract';
import { Employee } from '@models/employee/employee.model';

/**
 * Partial types, these are some the options we know exist, inferred by reverse engineering and console.log debugging.
 * https://help.chilipiper.com/hc/en-us/articles/360053800373-About-Concierge-Snippet-and-JS-API
 */
interface ChiliPiperSuccess {
    readonly slot: {
        readonly start: number;
    };
}
interface ChiliPiperOptions {
    lead: { [key: string]: string | number };
    onSuccess?: (data: ChiliPiperSuccess) => void;
    onError?: () => void;
    onClose?: () => void;
}
declare const ChiliPiper: {
    submit: (id: string, route: string, options: ChiliPiperOptions) => void;
};

@Injectable()
export class ChiliPiperService implements MeetingSchedulerService {
    readonly fallbackSubdomain = 'humi-ca';
    readonly fallbackRouter = 'implementation_router';

    constructor() {
        this.loadScript();
    }

    loadScript(): void {
        const script = document.createElement('script');
        script.id = 'chilipiper-snippet';
        script.src = 'https://js.chilipiper.com/marketing.js';
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    bookMeeting(employee: Employee): Promise<Date> {
        return new Promise((resolve, reject) => {
            const options = {
                lead: {
                    FirstName: employee.firstName,
                    LastName: employee.lastName,
                    Email: employee.account.email,
                    Phone: employee.phoneWork ?? employee.phoneMobile,
                },
                onSuccess: (data: ChiliPiperSuccess): void => {
                    // Send meeting through resolve
                    const unixTimestamp = data.slot.start;
                    const meeting = new Date(unixTimestamp);
                    resolve(meeting);
                    // Close the chili piper popup
                    setTimeout(() => {
                        const popupWindow = document.querySelector('.chilipiper-popup');
                        if (popupWindow) {
                            popupWindow.parentNode.removeChild(popupWindow);
                        }
                    }, 5000);
                },
                onError: (): void => {
                    reject('There was a problem with the ChiliPiper form');
                },
                onClose: (): void => {
                    reject('User closed the ChiliPiper form');
                },
            };

            ChiliPiper.submit(
                environment?.chiliPiper?.subdomain ?? this.fallbackSubdomain,
                environment?.chiliPiper?.router ?? this.fallbackRouter,
                options
            );
        });
    }
}
